import { render, staticRenderFns } from "./DashboardBrandsList.vue?vue&type=template&id=14e3ad3b&"
import script from "./DashboardBrandsList.vue?vue&type=script&lang=js&"
export * from "./DashboardBrandsList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBrandsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports